import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { useTranslation } from 'react-i18next';
import { CheckDiagram } from './CheckDiagram';
import { AutoPayCheckbox, HsaRadioField, MakeDefaultCheckbox, SelectField, TextField } from './fields';

const formatDigits = (max: number) => (value: string) => value.replace(/\D/g, '').slice(0, max);

export function BankAccountFields({
  autoPayEnrolled,
  fromAutopay,
}: {
  autoPayEnrolled: boolean;
  fromAutopay?: boolean;
}) {
  const { t } = useTranslation('members');
  const checkDiagramLabel = t('payments.addAccount.checkDiagramLabel');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-foreground">{t('payments.addAccount.bankSection')}</span>
        <span className="inline-flex items-center gap-1 text-xs font-medium text-success-foreground">
          <Icon name="lock" weight="solid" size="xs" /> {t('payments.addAccount.secured')}
        </span>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <TextField
          name="bank.routingNumber"
          label={t('payments.addAccount.routingNumber')}
          info={{
            label: checkDiagramLabel,
            content: <CheckDiagram heading={checkDiagramLabel} highlight="routing" />,
            contentClassName: 'max-w-none',
          }}
          inputMode="numeric"
          sensitive
          format={formatDigits(9)}
        />
        <TextField
          name="bank.accountNumber"
          label={t('payments.addAccount.accountNumber')}
          info={{
            label: checkDiagramLabel,
            content: <CheckDiagram heading={checkDiagramLabel} highlight="account" />,
            contentClassName: 'max-w-none',
          }}
          inputMode="numeric"
          sensitive
          format={formatDigits(17)}
        />
        <TextField name="bank.bankName" label={t('payments.addAccount.bankName')} />
        <SelectField
          name="bank.accountType"
          label={t('payments.addAccount.accountType')}
          options={[
            { value: 'checking', label: t('payments.addAccount.accountTypeOptions.checking') },
            { value: 'savings', label: t('payments.addAccount.accountTypeOptions.savings') },
            { value: 'other', label: t('payments.addAccount.accountTypeOptions.other') },
          ]}
        />
      </div>
      <HsaRadioField scope="bank" />
      <div className="space-y-2.5">
        <MakeDefaultCheckbox scope="bank" />
        <AutoPayCheckbox scope="bank" autoPayEnrolled={autoPayEnrolled} fromAutopay={fromAutopay} />
      </div>
    </div>
  );
}
